import React from 'react';
import styled from 'styled-components';
import ds from 'designsystem/index';
import Arrow from 'blocks/Arrow/Arrow';
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */

export const ValueListBoxWrapper = styled.div`
  position: relative;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.bold')};
`;

export const ValueListBoxSelect = styled.select`
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  width: 100%;
  padding: calc(${ds.get('metrics.xs')} / 2) 0;
  border: none;
  background-color: ${ds.brand('white')};
  border-bottom: 2px solid ${ds.brand('background')};
  outline: none;
  appearance: none;
  
  &::-ms-expand { 
    display: none;
  }
`;

export const ValueListBoxOption = styled.option`
  padding: calc(${ds.get('metrics.xs')} / 2);
  appearance: none;
`;

export const ValueListBoxDefaultOption = styled.div`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  background-color: ${ds.brand('white')};
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  width: 100%;
  padding: calc(${ds.get('metrics.xs')} / 2) 0;
`;

export const ValueListBoxArrow = Arrow.extend`
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
  margin: ${ds.get('metrics.xs')} calc(${ds.get('metrics.xs')} / 6);
  border: 1px solid ${ds.brand('product')};
  border-left: none;
  border-top: none;
  width: calc(${ds.get('metrics.xs')} * 2/3);
  height: calc(${ds.get('metrics.xs')} * 2/3);
`;

export const ValueListBoxItemCount = styled.span`
  color: ${ds.brand('product')};
  margin-left: calc(${ds.get('metrics.xs')} * 2/3);
`;

const NativeValueListBox = (props) => {
  const {
    categories,
    activeFilter,
    maxWidth,
    onSelect,
  } = props;

  return (
    <ValueListBoxWrapper maxWidth={maxWidth}>

      <ValueListBoxDefaultOption>
        {activeFilter.name}
        <ValueListBoxItemCount>
          {`(${activeFilter.count})`}
        </ValueListBoxItemCount>
      </ValueListBoxDefaultOption>

      <ValueListBoxSelect
        onChange={e => onSelect(e.target.value)}
        value={activeFilter.value}
      >
        {categories.map((item, i) => (
          <ValueListBoxOption
            value={item.value}
            key={i}
          >
            {item.name}
            {` (${item.count})`}
          </ValueListBoxOption>
        ))}
      </ValueListBoxSelect>
      <ValueListBoxArrow />
    </ValueListBoxWrapper>
  );
};

export default NativeValueListBox;



// WEBPACK FOOTER //
// ./src/blocks/FiltersList/NativeValueListBox/index.jsx